import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { Screens } from "navigation/routes";
import { useStore } from "hooks/use-store";

function ScreenAutoSwitcher() {
  const [searchParams, setSearchParams] = useSearchParams();

  const config = useStore((state) => state.config);
  const tripCaptain = useStore((state) => state.tripCaptain);
  const pairingRequest = useStore((state) => state.pairingRequest);
  const setScreen = useStore((state) => state.setScreen);

  useEffect(() => {
    const event = searchParams.get("event");

    // 1. Pairing screen (highest priority)
    if (pairingRequest) {
      setScreen(Screens.Pairing);
      return;
    }

    // 2. Captain selection requirement
    if (config) {
      const isRequired = config.company_settings?.force_captain_login;
      const hasCaptains = !!config.captains?.length;

      // tripCaptain === undefined means the backend hasn't reported captain
      // state yet — don't force the screen until we know there is none
      if (tripCaptain === null && isRequired && hasCaptains) {
        setScreen(Screens.CaptainSelection);
        return;
      }
    }

    // 3. Alert screen (lowest priority)
    if (event === "alert") {
      setScreen(Screens.Alerts);
      // clear the event param to prevent re-triggering
      searchParams.delete("event");
      setSearchParams(searchParams);
      return;
    }
  }, [searchParams, pairingRequest, config, tripCaptain, setScreen]);

  return null;
}

export default ScreenAutoSwitcher;
